import React, { useState } from 'react';
import { connect } from 'react-redux';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReportTab from '../ReportTab';
import BtnRefresh from '../buttons/BtnRefresh';
import BtnExpand from '../buttons/BtnExpand';
import RptMultiTotal from './views/RptMultiTotal';
import { Collapse } from 'bootstrap';

import { errorMessage, famName, tlzName, onlyUnique, cmp, rptTotal, rptTotalQty } from '../functions';

const mapStateToProps = (state) => {
	return {
		apiServer: state.apiServer,
		agent: state.agent,
		uid: state.uid,
		session: state.session,
		periodType: state.periodType,
		periodDateStart: state.periodDateStart,
		periodDateEnd: state.periodDateEnd
	}
}

const mapDispatchToProps = { errorMessage }

function RptOthersFamilyCodeMultiTotal(props){
	const [rpt_fam, setRptFam] = useState([]);
    const [isLoading,setIsLoading] = useState(false);

	const refresh = () => {
		setIsLoading(true);

		var F1031 = props.periodType;
		var F254 = props.periodDateStart;

		// logging needed
		fetch(props.apiServer + '?uid='+props.uid+'&session='+props.session+'&action=rpt_fam&agent='+props.agent+'&F1031='+F1031+'&F254='+F254)
		.then(response => response.json())
		.then(result => {
			// logging needed
			if(result.data){                
                setRptFam(result.data);
                setIsLoading(false);
                let collapsible = document.getElementById('collapse_FamilyCodeMultiTotals');
                if(!collapsible.classList.contains("show")){            
                    new Collapse(document.getElementById('collapse_FamilyCodeMultiTotals'));
                }
			}
			else{
				props.errorMessage("Error retrieving rpt_fam data: "+result.message);
                setIsLoading(false);
			}
		});
	}

	// FORMAT REPORT DATA FOR MULTI TOTAL REPORT
	var rptData = rpt_fam.map((record) => record.F16).filter(onlyUnique).sort().map((catNo) => {
		return ({
			description: catNo + ' ' + famName(rpt_fam, catNo),
			data: rpt_fam.filter((data) => data.F16 === catNo).sort(function (a, b) {
				return cmp(a.F1179, b.F1179) || cmp(a.F1034, b.F1034);
			}).map((record) => record.F1034).filter(onlyUnique).map((totalizer) => {
				return ({
					code: totalizer,
					description: tlzName(rpt_fam, totalizer),
					qty: rptTotalQty(rpt_fam.filter((rpt) => rpt.F16 === catNo), totalizer),
					dollars: rptTotal(rpt_fam.filter((rpt) => rpt.F16 === catNo), totalizer)
				})
			})
		});
	});
	

	return (
		<ReportTab id='FamilyCodeMultiTotals'>
			<ReportTab.Header parentId='FamilyCodeMultiTotals' title='Family Code Multi Totals'>
				<BtnRefresh parentId='FamilyCodeMultiTotals' loading={isLoading} action={refresh} />
				<BtnExpand parentId='FamilyCodeMultiTotals' action={refresh} />
			</ReportTab.Header>
			<ReportTab.Expand parentId='FamilyCodeMultiTotals'>
				<RptMultiTotal data={rptData} />
			</ReportTab.Expand>
		</ReportTab>
	);
}

export default connect(
        mapStateToProps,
        mapDispatchToProps
)(RptOthersFamilyCodeMultiTotal);

